import { render, staticRenderFns } from "./WaitBillList.vue?vue&type=template&id=dd4e521a&scoped=true"
import script from "./WaitBillList.vue?vue&type=script&lang=js"
export * from "./WaitBillList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4e521a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd4e521a')) {
      api.createRecord('dd4e521a', component.options)
    } else {
      api.reload('dd4e521a', component.options)
    }
    module.hot.accept("./WaitBillList.vue?vue&type=template&id=dd4e521a&scoped=true", function () {
      api.rerender('dd4e521a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/dialog/WaitBillList.vue"
export default component.exports